"use client";
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import "./SuccessBanner.css";

export default function SuccessBanner({
  open,
  message,
  duration = 2000,
  onClose,
}) {
  const { t } = useTranslation();

  // auto-hide après `duration`
  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(() => onClose?.(), duration);
    return () => clearTimeout(timer);
  }, [open, duration, onClose]);

  // ⚠️ Ne rien rendre si fermé
  if (!open) return null;

  return (
    <div className="sb-wrap" aria-live="polite">
      <div className="sb-box" role="status">
        <div className="sb-row">
          <div className="sb-check" aria-hidden>
            <svg
              viewBox="0 0 24 24"
              width="18"
              height="18"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M20 6L9 17l-5-5" />
            </svg>
          </div>

          {/* ✅ Titre traduit */}
          <div className="sb-title">
            {t("sucessbanner.success")}
          </div>
        </div>

        {/* ✅ Message traduit (fallback automatique) */}
        <div className="sb-message">
          {message || t("sucessbanner.successMessage")}
        </div>
      </div>
    </div>
  );
}

SuccessBanner.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string,
  duration: PropTypes.number,
  onClose: PropTypes.func,
};
